import React from 'react'
import t from '~t'
import { Checkbox } from '~ui'

export default function ExtensionTabsClose({ close, setClose }) {
    return (
        <>
            <div />
            <Checkbox
                checked={close}
                onChange={e=>setClose(e.target.checked)}>
                {t.s('closeTabs')}
            </Checkbox>
        </>
    )
}